import { ListLoader } from "@/loaders";

export default {
  applicationStatusSettingsList: new ListLoader("/application-status-settings/", {
    isSingleRequest: false,
  }),
};
